export default "__VITE_ASSET__D39Uapeo__"